$(document).ready( function(){

  $("[json]").click( function() { jsonurl = $(this).attr("json"); colurl = $(this).attr("colurl"); cid = $(this).attr("cid"); pnum =0; $("#R" + cid).html(""); 
    $(".Clink"+cid).removeClass("Cactive"); $(this).addClass("Cactive"); 
    jQuery.getJSON(jsonurl, function(obj) {           
      jQuery.each(obj.products, function(key,val) { pnum++; 
        if(pnum < 9) { 
          title = obj.products[key].title; handle = obj.products[key].handle; price = obj.products[key].variants[0].price; 
          imgage0 = obj.products[key].images[0].src; imgage1 = obj.products[key].images[1].src;                 
          $("#R" + cid).append("<div class='R-prod-card'><a href='" + "/products/" + handle + "'><div class='R-prod-card-mf'>" + 
            "<img class='img-over' src='" + imgage1 + "' width='100%'><div class='R-prod-card-in'><img src='" + imgage0 + "'></div></div>" + title + "<br>£" + price + "</a></div>"); 
        }
      }); 
    }); 
  }); 

  // SEARCH
  $(".fa-magnifying-glass").click( function() { $(".SearchDiv").slideToggle(); }); 
  $(".SearchDiv .fa-xmark").click( function() { $(".SearchDiv").slideToggle(); });
  $(".fa-arrow-right-long").click( function() { $(".SrchForm").submit(); }); 

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') { c = c.substring(1); }
      if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return "";
  }
  
  // RED CIRCLE ON BELL  
  if(getCookie("bellnum")!=1) { $(".bell span").css({ display:"inline-flex" }); } else { $(".bell span").css({ display:"none" }); } 
  
  // BELL CLICK
  $(".bell, .bell span").click( function() { 
    var date = new Date(); date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000); expires=date.toGMTString(); 
    document.cookie="bellnum=1;expires="+expires+";path=/"; 
    $(".bell span").css({ display:"none" }); 
    bntop = $(this).offset().top + 38;
    bnleft = $(this).offset().left - 478;
    $(".notif-outer").css({ top:bntop, left:bnleft }).show(); 
  }); 

  $(".notif-outer .fa-xmark").click( function() { 
    $(".notif-outer").hide(); 
  }); 

  // MOBILE MENU
  $(".burger").click( function(){ $(".mob-menu").slideToggle(300); return false; });   
  
  // GO TO TOP BUTTON
  $(".topbutt").hide();
  $(".topbutt").click( function(){ 
    $('html, body').animate({ scrollTop: $("body").offset().top }, 600); 
  }); 
  
});

